import { createRouter, createWebHistory } from 'vue-router'

// --- 1. 导入【所有】视图组件 ---
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import ApplyView from '../views/ApplyView.vue'
import EditProfileView from '../views/EditProfileView.vue'
import ChangePasswordView from '../views/ChangePasswordView.vue'
import AdminDashboardView from '../views/AdminDashboardView.vue'
import ForgotPasswordView from '../views/ForgotPasswordView.vue'
import ResetPasswordConfirmView from '../views/ResetPasswordConfirmView.vue'
import HomeView from '../views/HomeView.vue' // (会员门户)
import ActivityDetailView from '../views/ActivityDetailView.vue' // (会员详情)
import ResourceHubView from '../views/ResourceHubView.vue'
import UploadResourceView from '../views/UploadResourceView.vue'
import DirectoryView from '../views/DirectoryView.vue'
import PublicHomeView from '../views/PublicHomeView.vue' // (官网首页)
import PublicNewsView from '../views/PublicNewsView.vue' // (官网新闻)
import PublicActivityDetailView from '../views/PublicActivityDetailView.vue'
import ContactView from '../views/ContactView.vue' // 联系我们

// 【新增】导入研报列表组件
// 如果你没有创建 public 文件夹，而是直接放在 views 下，请改为 '../views/ReportsView.vue'
import ReportsView from '../views/ReportsView.vue'

// --- 2. 定义“网址地图” ---
const routes = [
  // --- “公共区”路由 (无需登录) ---
  {
    path: '/',
    name: 'PublicHome',
    component: PublicHomeView,
    meta: { title: '首页' }
  },
  {
    path: '/news',
    name: 'PublicNews',
    component: PublicNewsView,
    meta: { title: '新闻与公告' }
  },
  {
    path: '/news/:id',
    name: 'PublicActivityDetail',
    component: PublicActivityDetailView,
    meta: { title: '活动详情' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView,
    meta: { title: '联系我们' }
  },
  // 【新增】研报列表路由
  {
    path: '/reports',
    name: 'PublicReports',
    component: ReportsView,
    meta: { title: '行业研究报告' }
  },

  // --- 认证相关 ---
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { title: '会员登录' }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordView,
    meta: { title: '忘记密码' }
  },
  {
    path: '/reset-password-confirm',
    name: 'ResetPasswordConfirm',
    component: ResetPasswordConfirmView,
    meta: { title: '重置密码' }
  },

  // --- “会员区”路由 (需要登录) ---
  {
    path: '/home',
    name: 'Home',
    component: HomeView,
    meta: { title: '会员主页' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: { title: '个人中心' }
  },
  {
    path: '/apply',
    name: 'Apply',
    component: ApplyView,
    meta: { title: '积分申请' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: EditProfileView,
    meta: { title: '修改资料' }
  },
  {
    path: '/password',
    name: 'ChangePassword',
    component: ChangePasswordView,
    meta: { title: '修改密码' }
  },
  {
    path: '/admin-dashboard',
    name: 'AdminDashboard',
    component: AdminDashboardView,
    meta: { title: '管理后台' }
  },
  {
    path: '/activity/:id',
    name: 'ActivityDetail',
    component: ActivityDetailView,
    meta: { title: '活动详情' }
  },
  {
    path: '/resources',
    name: 'ResourceHub',
    component: ResourceHubView,
    meta: { title: '资源库' }
  },
  {
    path: '/resources/upload',
    name: 'UploadResource',
    component: UploadResourceView,
    meta: { title: '上传资源' }
  },
  {
    path: '/directory',
    name: 'Directory',
    component: DirectoryView,
    meta: { title: '会员通讯录' }
  },
]

// --- 3. 创建路由器 ---
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  // 滚动行为：切换页面时自动回到顶部
  scrollBehavior() {
    return { top: 0 }
  }
})

// --- 4. 路由守卫 ---
const baseTitle = '会员管理系统';

router.beforeEach((to, from, next) => {
  // 定义哪些页面是“公开的”，不需要登录
  const publicPages = [
    '/',                 // 官网首页
    '/news',             // 新闻列表
    '/contact',          // 联系我们
    '/reports',          // 【新增】研报列表必须公开，否则点击首页卡片会跳登录
    '/login',
    '/forgot-password',
    '/reset-password-confirm'
  ];

  const isAuthenticated = !!localStorage.getItem('authToken');

  // 检查是否是公开页 (包括以 /news/ 开头的详情页)
  const isPublicPage = publicPages.includes(to.path) || to.path.startsWith('/news/');

  // 逻辑 1: 未登录用户，访问会员区 -> 去登录
  if (!isPublicPage && !isAuthenticated) {
    return next({ name: 'Login' });
  }

  // 逻辑 2: 已登录用户，访问官网首页 -> 自动跳转到会员主页
  // (注意：如果你希望已登录用户也能看官网首页，可以注释掉下面这段代码)
  if (to.path === '/' && isAuthenticated) {
    return next({ name: 'Home' });
  }

  // 逻辑 3: 已登录用户，访问登录页 -> 去会员主页
  if (to.path === '/login' && isAuthenticated) {
     return next({ name: 'Home' });
  }

  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} | ${baseTitle}`;
  } else {
    document.title = baseTitle;
  }

  // 放行
  next();
});

export default router